export const createURL = (image) =>{
  return URL.createObjectURL(image);
}